const handleValidation = (state, fields) => {
  const validate = {};
  fields.map(field => {
    if (state[field] === '') {
      validate[field] = {
        error: true,
        message: `Field can't be empty!!`,
      };
    } else if (state[field].length < 8) {
      validate[field] = {
        error: true,
        message: `The field must be at least 8 characters long!!`,
      };
    } else if (field === 'ConfirmPassword') {
      if (state.ConfirmPassword !== state.NewPassword) {
        validate[field] = {
          error: true,
          message: `Password does not match!!`,
        };
      }
    } else {
      delete validate[field];
    }
    return validate;
  });

  return validate;
};

export default handleValidation;
